.preloader
    display: flex
    justify-content: center
    align-items: center
    position: absolute
    width: 100%
    height: 100%
    z-index: 9999
    background-color: #CD1D19
    transition: opacity 0.15s
    opacity: 1
    img
        width: 70%
    &.hide
        opacity: 0
        pointer-events: none